import styled from 'styled-components';
import {
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItem,
} from 'react-accessible-accordion';
import variables from '../../../styles/variables';

export const Section = styled.section`
  width: 100%;
  height: 100%;
  background-color: #f6f6f8;
  padding: 38px 0;
`;

export const SpecContainer = styled.div`
  max-width: ${variables.defaultWidth}px;
  margin: 0 auto;
  padding: 0 2rem;

  @media screen and (max-width: 400px) {
    padding: 0;
  }
`;

export const Specs = styled.div`
  max-width: 807px;
  height: 100%;
`;

export const ProductDetailWrapper = styled.div`
  border-bottom: 1px solid ${variables.colorGreyDark};

  @media screen and (max-width: 400px) {
    padding: 0 ${variables.mobileLayoutPadding}rem;
  }
`;

export const ProductDetailHeading = styled.h2`
  width: 100%;
  font-size: 30px;
  font-weight: 600;
  line-height: 34px;
  margin-bottom: 28px;
`;

export const ProductDetail = styled.div`
  width: 100%;
  margin-bottom: 28px;
  max-width: 600px;
  .p {
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
  }
`;

export const SpecAccordionItem = styled(AccordionItem)`
  margin: 18px 0;
  border-bottom: 1px solid ${variables.colorGreyDark};
  padding-bottom: 18px;
`;

export const SpecificationTitleWrapper = styled(AccordionItemHeading)`
  @media screen and (max-width: 400px) {
    padding: 0 ${variables.mobileLayoutPadding}rem;
  }
`;

export const SpecificationTitle = styled(AccordionItemButton)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 30px;
  font-weight: 600;
  line-height: 34px;
  letter-spacing: -0.25px;
  &[aria-expanded='true'] .chevron {
    transform: rotate(180deg);
    opacity: 1;
  }
`;
export const ChevronImage = styled.div`
  img {
    opacity: 0.5;
    width: 20px;
    height: auto;
  }
`;

export const ItemPanel = styled(AccordionItemPanel)`
  margin-top: 28px;
  @media screen and (max-width: 400px) {
    padding: 0 ${variables.mobileLayoutPadding}rem;
  }
`;
export const DataWrapper = styled.div`
  display: flex;
  margin-bottom: 38px;
  padding-left: 10px;

  @media screen and (max-width: 400px) {
    flex-wrap: wrap;
    flex-direction: column;
  }
  &:last-child {
    margin-bottom: 10px;
  }
`;

export const SpecName = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 17.87px;
  width: 40%;
  @media screen and (max-width: 400px) {
    margin-bottom: 12px;
    width: 85%;
  }
`;

export const SpecValue = styled.div`
  font-weight: 400;
  line-height: 16px;
  font-size: 16px;
  width: 50%;
  margin-left: 20px;
  @media screen and (max-width: 400px) {
    margin-left: 0;
    width: 85%;
  }
`;
